import { render, staticRenderFns } from "./LocationFormPropertyDetails.vue?vue&type=template&id=c2ca94de&scoped=true&"
import script from "./LocationFormPropertyDetails.vue?vue&type=script&lang=js&"
export * from "./LocationFormPropertyDetails.vue?vue&type=script&lang=js&"
import style0 from "./LocationFormPropertyDetails.vue?vue&type=style&index=0&id=c2ca94de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ca94de",
  null
  
)

export default component.exports